__turbopack_context__.v({
  "liveSportItem": "advanced-sidebar-live-sport-module-sass-module__dGLteW__liveSportItem",
});
